import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get GLAccount
export const getGLAccount = createAsyncThunk("glAccount/getGLAccount", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getGLAccount({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all GLAccount
export const getAllGLAccount = createAsyncThunk("glAccount/getAllGLAccount", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllGLAccount();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("glAccount/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("glAccount/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "glAccount/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;

    try {
      const { data } = await API.getPageGLAccount({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create GLAccount
export const createGLAccount = createAsyncThunk("glAccount/createGLAccount", async (param, { rejectWithValue }) => {
  const {
    name,
    code,
    accountGroup,
    partyAccount,
    mergedTo,
    controlAccount,
    openingBalance,
    postingsAllowed,
    isActive,
    merged,
    isCashAccount,
    remarks,
  } = param;
  try {
    const body = JSON.stringify({
      name,
      code,
      accountGroup,
      partyAccount,
      mergedTo,
      controlAccount,
      openingBalance,
      postingsAllowed,
      isActive,
      merged,
      isCashAccount,
      remarks,
    });
    const { data } = await API.createGLAccount(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

export const updateGLAccount = createAsyncThunk("glAccount/updateGLAccount", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const {
    name,
    code,
    accountGroup,
    partyAccount,
    mergedTo,
    controlAccount,
    openingBalance,
    postingsAllowed,
    isActive,
    merged,
    isCashAccount,
    remarks,
  } = values;
  try {
    const body = JSON.stringify({
      name,
      code,
      accountGroup,
      partyAccount,
      mergedTo,
      controlAccount,
      openingBalance,
      postingsAllowed,
      isActive,
      merged,
      isCashAccount,
      remarks,
    });
    const { data } = await API.updateGLAccount(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// get GLAccount
export const getGLAccountById = createAsyncThunk("glAccount/getGLAccountById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getGLAccountById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// handle search
export const handleSearch = createAsyncThunk("glAccount/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
